import {
    transform,
    isEqual,
    isObject,
    snakeCase,
    chain,
} from 'lodash';
import i18n from '@/i18n';

export default {

    difference(object, base) {
        function changes(object, base) {
            return transform(object, function(result, value, key) {
                if (!isEqual(value, base[key])) {
                    result[key] = (isObject(value) && isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }
        return changes(object, base);
    },

    pluralize (val, verb=''){
        if(val > 1 && verb === ''){
            return 's';
        }else{
            if(verb === 'be'){
                return val > 1 ? 'are' : 'is';
            }else if(verb === 'est'){
                return val > 1 ? 'sont' : 'est';
            }
        }
        return '';
    },

    invalidNameCase (val, type='model'){
        let verboseType = this.convertToPascalCase(type);
        let modelError = i18n.t('partials.helper.name_check_error.model');
        let fieldError = i18n.t('partials.helper.name_check_error.field');
        try{
            if(type === 'model'){
                if(val[0] !== val[0].toUpperCase() || val.includes('_')){
                    throw modelError;
                }
            }else{
                for( let char of val){
                    let alphabet = 'AZERTYUIOPQSDFGHJKLMNBVCXW';
                    if(alphabet.includes(char)){
                        throw fieldError;
                    }
                }
            }
            if(val.match(/[.,\/#!$%\^&\*;:{}=\-`~()\s'+<>?"@]/)){
                throw type === 'model' ? modelError : fieldError;
            }
        }catch(e){
            return {
                error: e,
                suggestion: type === 'model' ? this.convertToPascalCase(val) : snakeCase(val),
            };
        }
        return null;
    },
    convertToPascalCase (val){
        return chain(val.split(/[.,\/#!$%\^&\*;:{}=\-`~()\s']/).join('_')).camelCase().upperFirst().value();
    },
    removeProvisionalFieldsUid(schema){
        for(let model of schema.manifest.data_modeling.models){
            for(let field of model.fields){
                if(field.provisionalFieldUid){
                    delete field.provisionalFieldUid;
                }
            }
        }
        return schema;
    }
};



// WEBPACK FOOTER //
// ./src/components/Partials/helper.js